import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgSocialYouTube = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#88827E"
      d="M21.8 8.02s-.195-1.372-.796-1.974c-.762-.793-1.613-.797-2.004-.844C16.203 5 12.004 5 12.004 5h-.008S7.796 5 5 5.202c-.39.047-1.242.05-2.004.844-.601.602-.793 1.975-.793 1.975S2 9.634 2 11.244v1.508c0 1.61.2 3.223.2 3.223s.195 1.373.792 1.975c.762.793 1.762.766 2.207.852C6.801 18.953 12 19 12 19s4.203-.008 7-.206c.39-.047 1.242-.05 2.004-.844.601-.602.797-1.975.797-1.975s.199-1.61.199-3.223v-1.508c0-1.61-.2-3.223-.2-3.223ZM9.935 14.584V8.99l5.402 2.807-5.402 2.787Z"
    />
  </svg>
);
export default SvgSocialYouTube;
